import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactCardFlip from 'react-card-flip';

import styles from 'styles/TransportationGrant';
import TMessage from '../../containers/tiles/TMessage';
import TLoading from '../../containers/tiles/TLoading';
import FrontCard from './FrontCard';
import BackCard from './BackCard';

const TransportationGrant = ({
  loading, grant, embed, onSubmit,
}) => {
  const [flip, setFlip] = useState(false);
  const getOnClick = value => () => setFlip(value);

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <TLoading />
        </div>
      </div>
    );
  }

  if (!grant || !grant.Months) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <TMessage type="warning" message="transportationGrant.error" />
        </div>
      </div>
    );
  }

  return (
    <ReactCardFlip
      isFlipped={flip}
      containerStyle={embed ? styles.embedContainer : styles.container}
    >
      <FrontCard embed={embed} grant={grant} loading={loading} handleClick={getOnClick} />
      <BackCard embed={embed} grant={grant} loading={loading} handleClick={getOnClick} onSubmit={onSubmit} />
    </ReactCardFlip>
  );
};

TransportationGrant.propTypes = {
  loading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  embed: PropTypes.bool,
  grant: PropTypes.shape({
    HrTransportationGrantID: PropTypes.number.isRequired,
    HrTransportationGrantName: PropTypes.string.isRequired,
    PublicTransportation: PropTypes.string,
    Cycling: PropTypes.string,
    Walking: PropTypes.string,
    TransportationCard: PropTypes.string,
    Months: PropTypes.number,
    AmountPerMonth: PropTypes.string,
    Previous: PropTypes.arrayOf(PropTypes.shape({
      Begda: PropTypes.string,
      Endda: PropTypes.string,
    })),
  }).isRequired,
};

TransportationGrant.defaultProps = {
  loading: false,
  embed: false,
};

export default TransportationGrant;



// WEBPACK FOOTER //
// ./src/sites/transportationGrants/TransportationGrant.js